<template>
    <div>
        <!-- Tabel Sarana -->
        <div class="card">
            <div class="card-header">
                <div class="col-12 col-lg-12">
                    <div class="row">
                        <div class="col-6 col-lg-6 order-1 order-lg-1">
                            <h5
                                style="
                                    vertical-align: middle !important;
                                    float: left !important;
                                "
                            >
                                Data Berita Acara Sarana (Light Vihicle)
                                
                            </h5>
                        </div>
                        <div class="col-6 col-lg-6 order-2 order-lg-2">
                            <div class="col-12 col-lg-12">
                                <div class="d-flex justify-content-end">
                                    <a href="/sarana/ba/show" target="_blank"
                                        class="btn btn-sm btn-primary me-2"
                                        type="button"
                                    >
                                        <span class="tf-icons bx bx-plus"></span
                                        >&nbsp; Buat Berita Acara
                                        </a>
                                    <button
                                        ref="updateBtn"
                                        id="showToastPlacement"
                                        class="btn btn-sm btn-warning"
                                        type="button"
                                        @click="getBeritaAcara(halaman)"
                                    >
                                        <span
                                            class="tf-icons bx bx-refresh"
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive text-nowrap">
                <table class="table table-hover">
                    <caption class="ms-4" v-if="berita_acara.total > 0">
                        Showing
                        {{
                            berita_acara.from
                        }}
                        to
                        {{
                            berita_acara.to
                        }}
                        of
                        {{
                            berita_acara.total
                        }}
                        Sarana
                    </caption>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th colspan="2">Aksi</th>
                            <th>QrCode</th>
                            <th>Unit Sarana</th>
                            <th>Dibuat Oleh,</th>
                            <th>Waktu</th>
                            <th>Lampiran</th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>No</th>
                            <th colspan="2">Aksi</th>
                            <th>QrCode</th>
                            <th>Unit Sarana</th>
                            <th>Dibuat Oleh,</th>
                            <th>Waktu</th>
                            <th>Lampiran</th>
                        </tr>
                    </tfoot>
                    <tbody class="table-border-bottom-0">
                        <tr v-for="(a, b) in berita_acara.data" >
                            <td>
                                <strong>{{ berita_acara.from + b }}</strong>
                            </td>
                            <td >
                                <div class="dropdown">
                                    <button
                                        type="button"
                                        class="btn  p-0 dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    ><small>Menu</small>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a
                                            class="dropdown-item"
                                            target="_blank"
                                            :href="'/sarana/ba/'+a.kodeUnit+'/edit'"
                                        >
                                            <i class="bx bx-table me-1"></i>
                                            Detail
                                    </a>
                                        <button
                                            class="dropdown-item"
                                            @click="editSarana(a.idVehicle)"
                                        >
                                            <i class="bx bx-edit-alt me-1"></i>
                                            Edit
                                        </button>
                                        <button v-if="a.status ==1"
                                            class="dropdown-item"
                                            @click="disableSarana(a.idVehicle)"
                                        >
                                            <i class="bx bx-x me-1"></i>
                                            Disable
                                        </button>
                                        <button v-if="a.status ==0"
                                            class="dropdown-item"
                                            @click="disableSarana(a.idVehicle)"
                                        >
                                            <i class="bx bx-check me-1"></i>
                                            Disable
                                        </button>
                                        <button
                                            class="dropdown-item"
                                            @click="del(a.idVehicle)"
                                        >
                                            <i class="bx bx-trash me-1"></i>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: center">
                                <span
                                    :class="
                                        a.status
                                            ? 'badge me-1 bg-label-success'
                                            : 'badge me-1 bg-label-danger'
                                    "
                                    >{{
                                        a.status == 1 ? "Active" : "Non-Active"
                                    }}</span
                                >
                            </td>
                            <td>
                                <qrcode-vue :value=" a.kodeUnit " level="H" :image-settings='imageSettings' render-as="canvas" margin="1" size="50"/>
                                </td>
                            <td>
                                {{ a.noLambung }}
                                <br> {{ a.merkType}}
                            </td>
                            <td>{{ a.nama }}
                            </td>
                            <td>{{ moment(a.tanggal).format("DD MMMM YYYY") }} <br> {{ a.jam }}</td>
                            <td>
                                <center>
                                    <a :href="'/lampiran/berita_acara/'+a.lampiranBA" target="_blank" style="text-decoration: none!important;">
                        <i class='bx bx-file col-sm-12' style="font-size: 40px;"></i>
                                   <br> {{ a.lampiranBA }}
                                </a>
                                </center>
                                
                            </td>
                        </tr>
                        <tr v-if="berita_acara.total == 0">
                            <td>Tidak Ada Data</td>
                        </tr>
                    </tbody>
                </table>
                <div style="margin-top: 100px;">

                </div>
            </div>
            <div class="card-footer">
                <Bootstrap5Pagination
                    :data="berita_acara"
                    @pagination-change-page="getVehicle"
                />
            </div>
        </div>
        <!--/ Hoverable Table rows -->

    </div>
</template>

<script>
import axios from "axios";
import { Bootstrap5Pagination } from "laravel-vue-pagination";
import FormSarana from "./form/lv.vue";
import { ref } from "vue";
import moment from "moment";
import QrcodeVue, { QrcodeCanvas, QrcodeSvg ,ImageSettings} from 'qrcode.vue'

const focusRef = ref(null);

export default {
    components: {
        Bootstrap5Pagination,
        FormSarana,
        QrcodeSvg,
        QrcodeCanvas,
        QrcodeVue,
    },
    mounted() {
        this.csrfTokens = this.tokens;
        this.getBeritaAcara(this.halaman);
    },
    data() {
        return {
            moment: moment,
            berita_acara: {},
            halaman: 1,
            csrfTokens: "",
        };
    },
    props: ["tokens"],
    methods: {
        toast() {
            $("#myToast").toast("show");
        },
        getBeritaAcara(page) {
            if (page != undefined) {
                this.halaman = page;
            }
            axios
                .get("/sarana/ba/create?page=" + this.halaman)
                .then((response) => {
                    var ba = response.data;
                    if (ba != null) {
                        this.berita_acara = ba;
                    }
                });
        },
        del(idVehicle) {
            axios.delete("/sarana/lv/" + idVehicle).then((response) => {
                if (response != null) {
                    this.berita_acara = {};
                    this.getBeritaAcara(this.halaman);
                }
            });
        },
        doEmits(e) {
            
        },
        inputFocusEvent() {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.initDatas();
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

            bsOffcanvas.toggle();
        },
        editSarana(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.getByIds(id);

            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        detailSarana(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasDetailBoth");
            thisFocus.$refs.focusDetailRef.getByIds(id);
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        
    },
};
</script>